import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";

const Timer: React.FC = () => {
  const time = useSelector((state: RootState) => state.time.time);
  const metalType = useSelector((state: RootState) => state.shop.metalType);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="flex items-center gap-2">
      <img src="/alarm-filled.png" alt="clock image" className="h-2 sm:h-4" />
      <div>
        {metalType === "gold" ? (
          <p className="text-xxs sm:text-sm text-gold01">
            <span className="sm:inline">Gold Rate</span> expire in: {formatTime(time)}
          </p>
        ) : (
          <p className="text-xxs sm:text-sm text-gray-100">
            <span className="sm:inline">Silver Rate</span> expire in: {formatTime(time)}
          </p>
        )}
      </div>
    </div>
  );
};

export default Timer;